import React, { Component } from 'react';
import '../App.css';
import Sidemenu from '../components/Sidemenu';
import TopMenu from '../components/TopMenu';
import { getUserData, PostData, GetData, urls } from "../common";
import Spinner from '../Spinner.js';
import history from '../history';
import $ from "jquery";
import moment from "moment";

export default class DailyPoints extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdmin: false,
      user: {},
      profilePic: '',
      loggedin: false,
      loginMsg: "",
      loginLoading: false,
      purchaseHistory:[],
      loading:true
    };
  }
  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    var user = await getUserData();

    if (user !== null) {
      this.setState({ user: user, loggedin: true });

      this.setState({loading:true});
      var purchaseHistory = await GetData(urls.history+"1");
      if (purchaseHistory.code === 200) {
        this.setState({ purchaseHistory: purchaseHistory.message });
      }
      this.setState({loading:false});
    }
  };

  render() {
    const { purchaseHistory } = this.state;
    
    return (
      <div id="wrapper">

        <Sidemenu />
        {/* End of Sidebar */}

        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">

          {/* Main Content */}
          <div id="content">

            <TopMenu />

            <div className="container"><hr /></div>


            {/* questions */}
            {(this.state.loading==true)&& <center><Spinner bg={"#fff"} fill={"#444"} /><br/></center>}
            <div className="container">
              <div className="row">
                
                <div className="col-lg qborder">
                  <div className="card-header question">
                    <h6 className=" ">My Daily Points</h6>
                  </div>
                  <div className="list-group quiz">
                    <table width={"100%"}>
                      <thead>
                        <th>Date</th>
                        <th>Points</th>
                      </thead>
                      <tbody>
                        {purchaseHistory.map(function(data,index){
                            return (<tr>
                            <td>{moment(data.datetime).format("Do MMM,YYYY hh:mm a")}</td>
                            <td>{data.points_awarded} points</td>
                          </tr>);
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* questions-end */}




            </div>

            <hr />

            {/* </div> */}

            {/* Footer */}
            <footer className="sticky-footer bg-white">
              <div className="container my-auto">
                <div className="copyright text-center my-auto">
                  <span>Copyright &copy; nCartaBox {moment().format("YYYY")}</span>
                </div>
              </div>
            </footer>
            {/* End of Footer */}

          </div>
          {/* End of Content Wrapper */}

        </div>
        {/* End of Page Wrapper */}

        {/* Scroll to Top Button*/}
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </div>
    );
  }
}
